import { createContext } from 'react';
import { VehicleDetailContextProps } from './existing-vehicle.props';

export const VehicleDetailContext = createContext<VehicleDetailContextProps>({
  vehicle: {},
  setRefreshKey: () => console.error('setRefreshKey is not exist in VehicleDetailContext.')
});
